import awsmobile from "./aws-exports";

export const AWS_REGION = awsmobile.aws_project_region;
export const S3_BUCKET_ID = awsmobile.aws_user_files_s3_bucket;
